import CustomModal from '../../components/CustomModal';
import CustomModalContent from '../../components/CustomModal/CustomModalContent';
import DatePicker from '../../components/DatePicker';

type DatePickerModalProps = {
    value?: Date;
    onChange: (value?: Date) => void;
};

const DatePickerModal: React.FC<DatePickerModalProps> = ({ value, onChange }) => {
    return (
        <CustomModal modalName='datePickerModal' className='date-picker-modal'>
            <CustomModalContent>
                <DatePicker {...{ value, onChange }} />
            </CustomModalContent>
        </CustomModal>
    );
};

export default DatePickerModal;
